// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

@media (min-width: 768px) {
  .react-modal-overlay.event-display-warning-modal .react-modal {
    padding-top: 1rem;
    top: 15%;
    left: calc(50% - 16rem);
    width: 32rem;
    height: 35rem;
    height: -moz-fit-content;
    height: fit-content;
    max-height: 85%;
    box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);
    border-radius: 0.5rem;
    overflow-x: hidden;
  }
}
.react-modal-overlay.event-display-warning-modal .react-modal h1 {
  font-size: 1.8rem;
  font-style: italic;
  font-family: "Libre Baskerville";
  font-weight: 100;
  text-align: center;
  color: #333;
  margin-bottom: 1rem;
}
.react-modal-overlay.event-display-warning-modal .react-modal .actions {
  display: flex;
  justify-content: space-around;
  margin-top: 2rem;
}
.react-modal-overlay.event-display-warning-modal .react-modal .actions .btn.default {
  padding: 1rem 1.8rem;
  line-height: 1.2;
  font-size: 1.5rem;
  border: 0;
}
.react-modal-overlay.event-display-warning-modal .react-modal .actions .btn.ok {
  font-weight: 600;
}
.react-modal-overlay.event-display-warning-modal .react-modal .notes {
  font-size: 1.4rem;
  color: #333;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/ChangeDisplay/ChangeDisplayWarning.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAGI;EADF;IAEI,iBAAA;IACA,QAAA;IACA,uBAAA;IACA,YAAA;IACA,aAAA;IACA,wBAAA;IAAA,mBAAA;IACA,eAAA;IAGA,sDAAA;IACA,qBAAA;IACA,kBAAA;EACJ;AACF;AAAI;EACE,iBAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAEN;AAAI;EACE,aAAA;EACA,6BAAA;EACA,gBAAA;AAEN;AADM;EACE,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAGR;AADM;EACE,gBAAA;AAGR;AAAI;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;AAEN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Colors.scss';\n@import 'Variables.scss';\n\n.react-modal-overlay.event-display-warning-modal {\n  .react-modal {\n    @media (min-width: $tablet) {\n      padding-top: 1rem;\n      top: 15%;\n      left: calc(50% - 16rem);\n      width: 32rem;\n      height: 35rem;\n      height: fit-content;\n      max-height: 85%;\n      -webkit-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n      -moz-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n      box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n      border-radius: 0.5rem;\n      overflow-x: hidden;\n    }\n    h1 {\n      font-size: 1.8rem;\n      font-style: italic;\n      font-family: 'Libre Baskerville';\n      font-weight: 100;\n      text-align: center;\n      color: #333;\n      margin-bottom: 1rem;\n    }\n    .actions {\n      display: flex;\n      justify-content: space-around;\n      margin-top: 2rem;\n      .btn.default {\n        padding: 1rem 1.8rem;\n        line-height: 1.2;\n        font-size: 1.5rem;\n        border: 0;\n      }\n      .btn.ok {\n        font-weight: 600;\n      }\n    }\n    .notes {\n      font-size: 1.4rem;\n      color: #333;\n      text-align: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
